export default __webpack_public_path__ + "static/media/ET_2021-22.ea7773da.webm";